export default __webpack_public_path__ + "static/media/icon_home.5c0f931b.svg";